import { type RefObject, useRef } from 'react';
import { useIsInViewport } from './hooks';

const InViewport = ({
  onEnter,
  reference: initialReference,
}: {
  onEnter: () => unknown;
  reference?: RefObject<HTMLDivElement | null>;
}) => {
  const localReference = useRef<HTMLDivElement>(null);
  const reference = initialReference ?? localReference;

  useIsInViewport({
    onEnterViewPort: onEnter,
    reference,
  });

  return <div ref={reference} />;
};

export default InViewport;
